import { LinkSection } from "components/base/LinkSection";
import { CustomTitleLabel } from "components/earning/CustomBaseComponments";
import React from "react";
import { useFormContext } from "react-hook-form";

const ReactHookFormTextWithTitle = ({
  title,
  valueField,
  customValue,
  customRenderValue,
  showLinkButton = false,
  linkButtonInfo = {
    link: "",
    linkText: "View detail",
    disableLink: false,
    disableLinkText: "Deleted"
  },
  customRenderBottomDescription,
}) => {
  const { watch } = useFormContext();
  const value = customValue || watch(valueField);

  const displayLinkButton = {
    link: "",
    linkText: "View detail",
    disableLink: false,
    disableLinkText: "Deleted",
    ...linkButtonInfo,
  };

  return (
    <>
      <CustomTitleLabel title={title} />
      <div>
        {customRenderValue ? customRenderValue(value) :
          <label className="create-section-field-input profile-section-label-bottom">
            {value || '-'}
          </label>
        }
        {showLinkButton &&
          <LinkSection
            {...displayLinkButton}
          />
        }

      </div>
      {customRenderBottomDescription && customRenderBottomDescription()}
    </>
  )
}

export default ReactHookFormTextWithTitle;
